import React from "react";

import TelaGeral from "../../components/TelaGeral";
import { BsFillQuestionCircleFill } from "react-icons/bs";


export const SelecionaPrioritario = ({ isOpen, onRequestClose, handleIncluiFilaAtendimento}) => {
    return (
        <TelaGeral
            isOpen={isOpen}
            // onRequestClose={onRequestClose}
            titulo=""
            // className="modal-25"
        >
            <div className="prioritario-container">
                <div className="prioritario-client">
                    <BsFillQuestionCircleFill size={50} color="dodgerblue" />
                    <span>Atendimento prioritário?</span>
                </div>

                <div className="prioritario-bottom">
                    <button className="prioritario-botao" style={{backgroundColor: "tomato"}} onClick={() => {onRequestClose(); handleIncluiFilaAtendimento(null, false)}}>Não</button>
                    <button className="prioritario-botao" style={{backgroundColor: "green"}} onClick={() => {onRequestClose(); handleIncluiFilaAtendimento(null, true)}}>Sim</button>
                </div>
            </div>
        </TelaGeral>
    );
}